export const LANGUAGE_STORAGE_KEY = "accounts.selectedLanguageIref";
export const FALLBACK_LANGUAGE_CODE = "RO";
export const SUPPORTED_LANGUAGE_CODES = ["RO", "EN"];

const NORMALIZE_CODE = (value) => String(value || "").trim().toUpperCase();

export const LABELS = {
  RO: {
    "nav.home": "Acasă",
    "nav.products": "Produse",
    "nav.locations": "Locații",
    "nav.invoice": "Factură",
    "nav.feedback": "Feedback",
    "nav.app": "Aplicație",
    "nav.orderQuick": "Comandă rapid",
    "nav.order": "Comandă",
    "nav.more": "Mai mult",
    "nav.menu": "Meniu",
    "nav.openMenu": "Deschide meniul",
    "nav.primary": "Navigare principală",
    "nav.backToTop": "Înapoi sus",
    "nav.skipToContent": "Sari la conținut",
    "nav.login": "Autentificare",
    "nav.account": "Contul meu",
    "nav.accountFor": "Contul lui {name}",
    "nav.logout": "Deconectare",
    "language.label": "Limba",
    "language.change": "Schimbă limba",

    "common.loading": "Se încarcă...",
    "common.reset": "Reset",
    "common.all": "Toate",
    "common.allCategories": "Toate categoriile",
    "common.selectedCategory": "Categorie selectată",
    "common.viewDetails": "Vezi detalii",
    "common.productDetails": "Detalii produs",
    "common.backToProducts": "Înapoi la produse",
    "common.backToLocations": "Înapoi la locații",
    "common.unavailableAddress": "Adresă indisponibilă",
    "common.available": "disponibile",
    "common.close": "Închide",
    "common.previous": "Anterior",
    "common.next": "Următor",
    "common.image": "Imagine",
    "common.noImage": "Nicio imagine",
    "common.optional": "opțional",
    "common.retry": "Încearcă din nou",
    "common.loadErrorTitle": "Nu am putut încărca meniul",
    "common.loadError":
      "Conexiunea nu este disponibilă momentan. Încearcă din nou.",
    "common.publicContentError":
      "Unele informații despre restaurant nu s-au actualizat.",
    "common.offlineTitle": "Ești offline",
    "common.offline":
      "Poți răsfoi ce este deja încărcat. Reconectează-te pentru informații actualizate și comenzi.",
    "common.backOnline": "Conexiunea a revenit.",

    "portal.common.loading": "Se încarcă...",
    "portal.common.retry": "Încearcă din nou",
    "portal.common.sectionError":
      "Nu am putut încărca această secțiune. Încearcă din nou.",
    "portal.common.partialError":
      "Unele informații nu au putut fi încărcate.",
    "portal.common.empty": "Nu există informații disponibile momentan.",
    "portal.guard.restoring": "Se restabilește sesiunea contului",

    "portal.login.title": "Autentifică-te în contul tău",
    "portal.login.subtitle": "Vezi codul QR, punctele și ofertele tale.",
    "portal.login.optional":
      "Poți vedea meniul și comanda și fără autentificare.",
    "portal.login.expired":
      "Sesiunea a expirat. Autentifică-te din nou pentru a continua.",
    "portal.login.username": "Utilizator sau email",
    "portal.login.password": "Parolă",
    "portal.login.submit": "Autentificare",
    "portal.login.pending": "Se face autentificarea...",
    "portal.login.restoring": "Se restabilește sesiunea...",
    "portal.login.failed":
      "Nu te-am putut autentifica. Verifică datele și încearcă din nou.",
    "portal.login.createTitle": "Nu ai încă un cont?",
    "portal.login.createText":
      "Creează-l în câțiva pași și vei putea comanda folosind contul tău.",
    "portal.login.createAction": "Creează cont",

    "portal.register.title": "Creează-ți contul",
    "portal.register.subtitle":
      "Te poți autentifica și comanda imediat după creare.",
    "portal.register.firstName": "Prenume",
    "portal.register.lastName": "Nume",
    "portal.register.email": "Email",
    "portal.register.county": "Județ",
    "portal.register.countiesLoading": "Se încarcă județele...",
    "portal.register.countiesError":
      "Nu am putut încărca județele.",
    "portal.register.noCounties": "Nu am găsit județul.",
    "portal.register.city": "Localitate",
    "portal.register.citiesLoading": "Se încarcă localitățile...",
    "portal.register.citiesError":
      "Nu am putut încărca localitățile.",
    "portal.register.noCities": "Nu am găsit localitatea.",
    "portal.register.password": "Parolă",
    "portal.register.passwordConfirmation": "Repetă parola",
    "portal.register.passwordHint":
      "Minimum 8 caractere: majusculă, minusculă, cifră și simbol.",
    "portal.register.submit": "Creează cont",
    "portal.register.pending": "Se creează contul...",
    "portal.register.required": "Completează acest câmp.",
    "portal.register.emailInvalid": "Introdu o adresă de email validă.",
    "portal.register.passwordInvalid":
      "Parola nu respectă cerințele de mai sus.",
    "portal.register.passwordMismatch": "Parolele nu coincid.",
    "portal.register.languageUnavailable":
      "Limba contului nu este încă disponibilă. Încearcă din nou.",
    "portal.register.exists":
      "Există deja un cont cu aceste date. Încearcă să te autentifici.",
    "portal.register.failed":
      "Nu am putut crea contul. Dacă este posibil să fi fost deja creat, încearcă să te autentifici sau revino puțin mai târziu.",
    "portal.register.successTitle": "Cont creat",
    "portal.register.successText":
      "Te poți autentifica și comanda chiar acum.",
    "portal.register.validationInfo":
      "Verifică mesajul primit pe email și validează adresa pentru a vedea ofertele. Până atunci poți plasa comenzi.",
    "portal.register.haveAccount": "Ai deja un cont?",
    "portal.register.haveAccountText":
      "Autentifică-te pentru a vedea informațiile contului tău.",
    "portal.register.signIn": "Autentificare",

    "portal.account.title": "Contul meu",
    "portal.account.greeting": "Bine ai venit, {name}!",
    "portal.account.fallbackName": "client",
    "portal.account.summary":
      "Codul QR, punctele, ofertele și noutățile tale într-un singur loc.",
    "portal.account.emailValidationPending":
      "Poți plasa comenzi acum. Validează adresa de email pentru a vedea ofertele tale.",
    "portal.points.title": "Punctele tale",
    "portal.points.one": "punct",
    "portal.points.many": "puncte",
    "portal.points.unavailable": "Indisponibil",
    "portal.points.rate": "1 punct = 1 RON.",
    "portal.points.usage":
      "Poți folosi punctele în aplicația mobilă sau când comanzi prin personalul nostru.",

    "portal.qr.title": "Codul meu QR",
    "portal.qr.description": "Arată acest cod când ți se solicită.",
    "portal.qr.imageLabel": "Cod QR pentru identificarea contului",
    "portal.qr.code": "Cod",
    "portal.qr.copy": "Copiază codul",
    "portal.qr.copied": "Copiat",
    "portal.qr.copyFailed":
      "Selectează codul și copiază-l manual.",
    "portal.qr.validUntil": "Valabil până la {date}",
    "portal.qr.empty": "Codul QR nu este disponibil momentan.",
    "portal.qr.emailValidationPending":
      "Codul QR va apărea după validarea adresei de email.",

    "portal.offers.title": "Oferte",
    "portal.offers.description":
      "Vezi ofertele disponibile și pe cele revendicate.",
    "portal.offers.productGroup": "Oferte pentru produse",
    "portal.offers.comboGroup": "Oferte pentru combo",
    "portal.offers.voucherGroup": "Vouchere",
    "portal.offers.personalGroup": "Oferte pentru tine",
    "portal.offers.otherGroup": "Alte oferte",
    "portal.offers.fallback": "Ofertă",
    "portal.offers.personalFallback": "Ofertă personală",
    "portal.offers.claim": "Revendică",
    "portal.offers.claiming": "Se revendică...",
    "portal.offers.claimed": "Revendicat",
    "portal.offers.claimSuccess": "Oferta a fost revendicată.",
    "portal.offers.alreadyClaimed":
      "Oferta este deja revendicată sau nu mai este disponibilă.",
    "portal.offers.claimUnavailable":
      "Oferta nu poate fi revendicată momentan.",
    "portal.offers.empty": "Nu ai oferte momentan.",
    "portal.offers.emailValidationPending":
      "Ofertele vor apărea după validarea adresei de email.",
    "portal.offers.free": "Gratuit",
    "portal.offers.fixedPrice": "Preț fix: {value} RON",
    "portal.offers.comboBasePrice":
      "Preț de bază combo: {value} RON; extraopțiunile pot costa suplimentar",
    "portal.offers.comboBaseFree":
      "Baza combo este gratuită; extraopțiunile pot costa suplimentar",
    "portal.offers.fullCart":
      "Produsele din coș sunt gratuite; livrarea nu este inclusă",
    "portal.offers.fixed": "Reducere de {value} RON",
    "portal.offers.percentage": "Reducere de {value}%",
    "portal.offers.productScope": "Pentru un produs",
    "portal.offers.comboScope": "Pentru un combo",
    "portal.offers.productComboScope":
      "Legată atât de un produs, cât și de un combo",
    "portal.offers.voucherScope":
      "Se aplică întregului coș; livrarea nu este inclusă",
    "portal.offers.personalScope": "Ofertă alocată contului tău",
    "portal.offers.useOnce": "O singură utilizare",
    "portal.offers.onceDaily": "O dată pe zi",
    "portal.offers.onceWeekly": "O dată pe săptămână",
    "portal.offers.onceMonthly": "O dată pe lună",
    "portal.offers.ages": "Pentru vârste între {from} și {to} ani",
    "portal.offers.ageFrom": "De la {age} ani",
    "portal.offers.ageTo": "Până la {age} ani",
    "portal.offers.birthday": "Disponibilă de ziua ta",
    "portal.offers.from": "De la {date}",
    "portal.offers.until": "Până la {date}",

    "portal.news.title": "Noutăți",
    "portal.news.description": "Ultimele noutăți pentru tine.",
    "portal.news.fallback": "Noutate",
    "portal.news.empty": "Nu ai noutăți momentan.",

    "home.subtitle": "Descoperă gustul și povestea restaurantului.",
    "home.heroBrand":
      "Descoperă preparatele, atmosfera și povestea {brand}.",
    "home.heroFallback":
      "Descoperă preparatele, atmosfera și povestea restaurantului.",
    "home.heroCarousel": "Campanii și noutăți",
    "home.showHero": "Arată campania",
    "home.viewProducts": "Descoperă preparatele",
    "home.findLocation": "Vizitează-ne",
    "home.quick.products": "Produse",
    "home.quick.categories": "Categorii",
    "home.quick.locations": "Locații",
    "home.quick.app": "Aplicație",
    "home.quick.order": "Comandă",
    "home.card.products.title": "Produse pregătite cu grijă",
    "home.card.products.text": "Alege rapid din produsele disponibile și descoperă preferatele tale.",
    "home.card.fast.title": "Experiență rapidă",
    "home.card.fast.text": "Navigare simplă, clară și optimizată pentru telefon.",
    "home.card.locations.title": "Locații la îndemână",
    "home.card.locations.text": "Găsește ușor locațiile disponibile pentru tine.",
    "home.featuredStories": "Povești și noutăți",
    "home.popularCategories": "Descoperă meniul",
    "home.popularCategoriesDesc": "Explorează o selecție din preparatele restaurantului.",
    "home.allProducts": "Descoperă tot meniul",
    "home.recommendations": "Preparate de descoperit",
    "home.recommendationsDesc": "O selecție din meniul restaurantului.",
    "home.viewAll": "Vezi tot",
    "home.recommended": "Recomandat",
    "home.product": "Produs",
    "home.appTitle": "Restaurantul, mai aproape de tine.",
    "home.appDesc":
      "Descoperă meniul, noutățile și beneficiile disponibile în aplicație.",
    "home.downloadApp": "Descarcă aplicația",
    "home.viewMenu": "Vezi meniul",
    "home.nearestLocation": "Vino să ne vizitezi",
    "home.locationsDesc": "Descoperă restaurantele, adresele și informațiile utile pentru vizita ta.",
    "home.viewLocations": "Descoperă restaurantele",
    "home.appAlt": "Aplicația restaurantului",
    "home.locationsEmpty": "Locațiile disponibile vor fi afișate aici.",

    "products.heroTitle": "Descoperă meniul nostru.",
    "products.heroSubtitle": "Explorează preparatele și găsește gustul potrivit pentru momentul tău.",
    "products.displayed": "produse afișate",
    "products.count": "produse",
    "products.activeFilter": "Filtru activ",
    "products.search": "Caută produs...",
    "products.explore": "Explorează meniul",
    "products.loadingTitle": "Se încarcă produsele",
    "products.loadingDesc": "Pregătim meniul disponibil pentru această locație.",
    "products.errorTitle": "Nu am putut încărca produsele",
    "products.emptyTitle": "Nu am găsit produse",
    "products.emptyDesc": "Încearcă un alt cuvânt sau selectează altă categorie.",
    "products.resetFilters": "Resetează filtrele",
    "products.notFoundTitle": "Produsul nu a fost găsit.",
    "products.notFoundDesc": "Verifică lista de produse disponibile.",
    "products.new": "Produs nou",
    "products.newShort": "Nou",
    "products.deliverable": "Disponibil pentru livrare",
    "products.allergens": "Alergeni",

    "locations.heroTitle": "Restaurantele noastre.",
    "locations.heroSubtitle":
      "Descoperă unde ne găsești și informațiile utile pentru următoarea ta vizită.",
    "locations.displayed": "locații afișate",
    "locations.count": "locații",
    "locations.cityOne": "oraș disponibil",
    "locations.cityMany": "orașe disponibile",
    "locations.searchLong": "Caută după oraș, adresă sau telefon...",
    "locations.searchShort": "Oraș, adresă sau telefon...",
    "locations.find": "Găsește locația",
    "locations.loadingTitle": "Se încarcă locațiile",
    "locations.loadingDesc": "Pregătim lista de locații disponibile.",
    "locations.errorTitle": "Nu am putut încărca locațiile",
    "locations.emptyTitle": "Nu am găsit locații",
    "locations.emptyDesc": "Încearcă să cauți după oraș, adresă sau număr de telefon.",
    "locations.resetSearch": "Resetează căutarea",
    "locations.notFoundTitle": "Locația nu a fost găsită.",
    "locations.notFoundDesc": "Verifică lista locațiilor disponibile.",
    "locations.location": "Locație",
    "locations.call": "Sună",
    "locations.directions": "Indicații",
    "locations.copyAddress": "Copiază adresa",
    "locations.map": "Hartă",
    "locations.about": "Despre locație",
    "locations.schedule": "Program",

    "appDownload.app": "Restaurant App",
    "appDownload.alt": "Aplicația restaurantului",
    "appDownload.install": "Instalează aplicația",
    "appDownload.subtitle":
      "Comandă mai ușor și bucură-te de beneficiile disponibile în contul tău.",
    "appDownload.copy":
      "Ai acces rapid la produse, promoții personalizate, puncte de loialitate și o experiență mai simplă la fiecare comandă.",
    "appDownload.fast": "Comandă mai rapid",
    "appDownload.loyalty": "Promoții și loialitate",
    "appDownload.simple": "Totul la îndemână",
    "appDownload.appStore": "Descarcă din App Store",
    "appDownload.playStore": "Descarcă din Google Play",
    "appDownload.availability":
      "Disponibilitatea aplicației poate varia în funcție de dispozitiv și magazinul de aplicații.",
    "appDownload.unavailableTitle":
      "Descărcarea aplicației nu este disponibilă",
    "appDownload.unavailable":
      "Momentan nu este disponibil niciun link verificat către magazinul de aplicații. Poți continua să folosești acest site.",

    "productInfo.new": "Nou",
    "productInfo.close": "Închide detaliile produsului",
    "productInfo.description": "Descriere",
    "productInfo.ingredients": "Ingrediente",
    "productInfo.allergens": "Alergeni",
    "productInfo.nutrition": "Valori nutriționale",
    "productInfo.details": "Detalii",
    "productInfo.emptyTitle": "Informații produs",
    "productInfo.emptyText": "Nu există detalii suplimentare disponibile pentru acest produs.",
    "nutrition.energy": "Energie",
    "nutrition.protein": "Proteine",
    "nutrition.carbs": "Carbohidrați",
    "nutrition.sugars": "Zahăruri",
    "nutrition.fat": "Grăsimi",
    "nutrition.salt": "Sare",
    "nutrition.weight": "Gramaj",

    "mobile.emailUnavailable": "Indisponibil",
    "mobile.closeWhenFinished": "Poți închide această pagină când ai terminat.",
    "mobile.validateEmailTitle": "Verificare email",
    "mobile.validateEmailIntro": "Confirmăm adresa de email pentru contul tău.",
    "mobile.invalidEmailLink": "Linkul de verificare email este invalid sau incomplet.",
    "mobile.emailVerificationFailed": "Verificarea emailului nu a putut fi finalizată.",
    "mobile.emailChecking": "Verificăm linkul de email.",
    "mobile.invalidResetLink": "Linkul de resetare parolă este invalid sau incomplet.",
    "mobile.resetPasswordTitle": "Resetare parolă",
    "mobile.resetPasswordIntro": "Alege o parolă nouă pentru contul tău.",
    "mobile.resetPasswordSuccessTitle": "Parola a fost schimbată",
    "mobile.resetPasswordSuccessText": "Poți reveni în aplicație și te poți autentifica folosind noua parolă.",
    "mobile.openResetAgain": "Te rugăm să redeschizi linkul de resetare primit pe email.",
    "mobile.passwordMismatch": "Parolele nu coincid.",
    "mobile.passwordChanged": "Parola a fost schimbată.",
    "mobile.passwordNotChanged": "Parola nu a fost schimbată.",
    "mobile.newPassword": "Parolă nouă",
    "mobile.repeatPassword": "Repetă parola",
    "mobile.passwordHint": "Folosește minimum 8 caractere cu majusculă, minusculă, cifră și simbol.",
    "mobile.changePassword": "Schimbă parola",
    "mobile.showPassword": "Afișează parola",
    "mobile.hidePassword": "Ascunde parola",

    "days.1": "Luni",
    "days.2": "Marți",
    "days.3": "Miercuri",
    "days.4": "Joi",
    "days.5": "Vineri",
    "days.6": "Sâmbătă",
    "days.7": "Duminică",
    "days.day": "Ziua",

    "skipline.tagline": "Comandă rapid și ridică din locație",
    "skipline.chooseLocation": "Alege locația",
    "skipline.chooseLocationDesc": "Selectează județul și locația de unde vrei să ridici comanda.",
    "skipline.searchLocation": "Caută județ, oraș sau locație...",
    "skipline.termsPrefix": "Pagina oficială {brand} · plata securizată prin {provider}. Continuând, ești de acord cu",
    "skipline.terms": "Termenii",
    "skipline.and": "și",
    "skipline.privacy": "Politica de confidențialitate",
    "skipline.noLocations": "Nu există locații disponibile pentru comenzi online.",
    "skipline.noSearchLocations": "Nu am găsit nicio locație pentru căutarea introdusă.",
    "skipline.locationOne": "locație",
    "skipline.locationMany": "locații",
    "skipline.choose": "Alege",
    "skipline.change": "Schimbă",
    "skipline.startOrder": "Începem comanda",
    "skipline.emailNeeded": "Avem nevoie de email pentru procesarea plății online.",
    "skipline.openNow": "Deschis acum",
    "skipline.closedNow": "Închis acum",
    "skipline.canContinue": "Poți continua comanda pentru ridicare din locație.",
    "skipline.onlineUnavailable": "Comenzile online nu sunt disponibile momentan.",
    "skipline.paymentEmail": "Email pentru plată",
    "skipline.invalidEmail": "Email invalid",
    "skipline.emailHelp": "Emailul este folosit doar pentru procesarea plății.",
    "skipline.continueMenu": "Continuă la meniu",
    "skipline.menuOnlyOpen": "Meniul este disponibil doar când locația acceptă comenzi online.",
    "skipline.noAccount": "Nu creăm cont de client. Datele sunt folosite pentru această comandă.",
    "skipline.selectedLocation": "Locație selectată",
    "skipline.homeIntro": "Comandă rapid, plătește online și ridică din locație.",
    "skipline.chooseCategory": "Alege categoria",
    "skipline.chooseCategoryDesc": "Selectează o categorie pentru a vedea produsele disponibile.",
    "skipline.noCategories": "Nu există categorii disponibile pentru această locație.",
    "skipline.viewProducts": "Vezi produse",
    "skipline.chooseCombo": "Alege combo",
    "skipline.add": "Adaugă",
    "skipline.combo": "Combo",
    "skipline.promo": "Promo",
    "skipline.product": "Produs",
    "skipline.cart": "Coș",
    "skipline.yourOrder": "Comanda ta",
    "skipline.totalOrder": "Total comandă",
    "skipline.menu": "Meniu",
    "skipline.allMenu": "Tot meniul",
    "skipline.allProducts": "Toate produsele",
    "skipline.availableProducts": "{count} produse disponibile",
    "skipline.open": "Deschis",
    "skipline.closed": "Închis",
    "skipline.viewCart": "Vezi coșul",
    "skipline.clearCart": "Golește",
    "skipline.checkout": "Continuă la plată",
    "skipline.noProductsCategory": "Nu am găsit produse în această categorie.",
    "skipline.itemOne": "produs",
    "skipline.itemMany": "produse",
    "skipline.inCart": "în coș",
    "skipline.piece": "buc",
    "skipline.emptyCart": "Coșul este gol",
    "skipline.emptyCartDesc": "Adaugă produse din meniu pentru a continua comanda.",
    "skipline.backToMenu": "Înapoi la meniu",
    "skipline.securePayment":
      "Plata este procesată securizat prin {provider}. Nu introduce datele cardului decât pe pagina {provider} deschisă din această comandă.",
    "skipline.closeCart": "Închide coșul",
    "skipline.searchMenu": "Caută în meniu...",
    "skipline.clearFilter": "Șterge filtrul",
    "skipline.loadingMenu": "Nu am putut încărca meniul.",
    "skipline.loadingInit": "Nu am putut inițializa pagina.",
    "skipline.loadingSelectedLocation": "Nu am putut încărca meniul pentru locația selectată.",
    "skipline.locationChangeConfirm": "Schimbarea locației va goli coșul. Continui?",
    "skipline.otherCity": "Alt oraș",
    "skipline.noPaymentLink": "Nu am primit linkul de plată.",
    "skipline.addItems": "Adaugă produse în coș.",
    "skipline.enterPaymentEmail": "Introdu o adresă de email validă pentru plata online.",
    "skipline.orderRegistered":
      "Comanda a fost înregistrată. Pentru confirmare, continuă la plata online cu cardul.",
    "skipline.orderError": "A apărut o eroare la plasarea comenzii.",
    "skipline.vatUnavailable":
      "Nu putem calcula TVA-ul pentru unul dintre produsele din comandă. Reîncarcă meniul sau alege din nou produsul.",
    "skipline.orderAddUncertain":
      "Nu am putut confirma dacă a fost creată comanda. Nu încerca automat din nou; verifică situația înainte de o nouă comandă.",
    "skipline.paymentRegistrationFailed":
      "Comanda este păstrată, dar plata nu a putut fi inițializată. Reîncearcă plata pentru aceeași comandă.",
    "skipline.retryPaymentRegistration": "Reîncearcă inițializarea plății",
    "skipline.clientSessionRequired":
      "Sesiunea ta a expirat. Autentifică-te din nou pentru a continua aceeași comandă.",
    "skipline.clientSessionRestoring":
      "Îți restabilim sesiunea. Încearcă din nou în câteva momente.",
    "skipline.authenticatedPaymentUnavailable":
      "Plata pentru comanda din cont nu este disponibilă momentan.",
    "skipline.clientCheckoutActive": "Comandă din contul tău",
    "skipline.clientSignedIn": "Ești autentificat",
    "skipline.clientLogout": "Deconectare",
    "skipline.clientSignInForCheckout": "Ai cont?",
    "skipline.clientSignInHelp":
      "Autentifică-te fără să pierzi produsele din coș.",
    "skipline.clientBaseOrderHelp":
      "Comanda va fi asociată contului tău. Punctele și ofertele nu se aplică comenzilor de pe site.",
    "skipline.clientBenefitsUnavailable":
      "Comenzile de pe site nu pot include puncte sau oferte din cont.",
    "skipline.clientAccountEmailReady":
      "Comanda va fi asociată contului tău. Vom folosi adresa de email salvată în cont.",
    "skipline.clientAccountEmailMissing":
      "Nu putem plasa comanda deoarece contul tău nu are o adresă de email validă. Contactează-ne pentru actualizarea contului sau deconectează-te pentru a comanda fără cont.",
    "skipline.paymentSuccess": "Plata a fost procesată cu succes.",
    "skipline.paymentPending": "Plata nu este finalizată încă. După ce confirmi plata, apasă \"Am plătit\".",
    "skipline.paymentCanceled": "Plata a fost anulată. Poți reîncerca.",
    "skipline.paymentCheckFailed": "Nu am putut verifica statusul plății.",
    "skipline.paymentStatus": "Stare plată: {status}.",
    "skipline.cancelFailed": "Nu am putut anula comanda. Încearcă din nou.",
    "skipline.locationUnavailable": "Locația nu acceptă comenzi în acest moment.",
    "skipline.noLocationInfo": "Fără informații despre locație.",
    "skipline.inactiveLocation": "Locația este inactivă.",
    "skipline.unsupportedServeType": "Locația nu acceptă comenzi în acest mod.",
    "skipline.noTodaySchedule": "Nu există program pentru astăzi.",
    "skipline.closedSchedule": "Închis acum. Program astăzi: {open}-{close} (comenzi online).",

    "payment.finalize": "Finalizează plata",
    "payment.confirmedAfter": "Comanda este confirmată după procesarea plății online.",
    "payment.close": "Închide plata",
    "payment.online": "Plata online",
    "payment.secure":
      "Plata este procesată securizat prin {provider}. {owner} nu solicită și nu stochează datele cardului.",
    "payment.secureTitle": "Plată securizată",
    "payment.openOnline": "Deschide plata online",
    "payment.cardOnlyProvider":
      "Introdu datele cardului doar pe pagina {provider} deschisă din această comandă. După finalizarea plății, revino aici pentru verificarea statusului.",
    "payment.stepPay": "Finalizează plata în fereastra securizată.",
    "payment.stepReturn": "Revino aici și apasă \"Am plătit\".",
    "payment.checking": "Verificăm statusul plății...",
    "payment.afterPay": "După ce finalizezi plata, apasă \"Am plătit\" pentru verificare.",
    "payment.iPaid": "Am plătit",
    "payment.checkingShort": "Se verifică...",
    "payment.cancel": "Anulează",
    "payment.registrationFailed":
      "Inițializarea plății a eșuat, dar comanda cunoscută a fost păstrată.",
    "payment.retryRegistration": "Reîncearcă plata pentru aceeași comandă",
    "payment.retryingRegistration": "Reîncercăm plata...",
    "payment.sameOrderRetry":
      "Această acțiune nu creează o comandă nouă.",
    "payment.clientSessionRequired":
      "Autentifică-te din nou înainte de a relua această comandă.",
    "payment.clientUsername": "Utilizator sau email",
    "payment.clientPassword": "Parolă",
    "payment.clientSignIn": "Autentificare",
    "payment.clientSigningIn": "Autentificare...",
    "payment.clientLoginFailed":
      "Autentificarea a eșuat. Verifică datele sau încearcă mai târziu.",

    "combo.optionsFor": "Opțiuni pentru: {combo}",
    "combo.included": "Incluse în combo",
    "combo.includedPrice": "0 RON (inclus)",
    "combo.edit": "Editează",
    "combo.back": "Înapoi",
    "combo.addToCart": "Adaugă în coș",
    "combo.total": "Total combo",

    "summary.confirmed": "Comanda a fost confirmată",
    "summary.order": "Comandă",
    "summary.orderedProducts": "Produse comandate",
    "summary.keepConfirmation": "Păstrează această confirmare. Ridică produsul din locație când este pregătit.",
    "summary.totalPaid": "Total plătit",
    "summary.newOrder": "Comandă nouă",
  },

  EN: {
    "nav.home": "Home",
    "nav.products": "Products",
    "nav.locations": "Locations",
    "nav.invoice": "Invoice",
    "nav.feedback": "Feedback",
    "nav.app": "App",
    "nav.orderQuick": "Quick order",
    "nav.order": "Order",
    "nav.more": "More",
    "nav.menu": "Menu",
    "nav.openMenu": "Open menu",
    "nav.primary": "Primary navigation",
    "nav.backToTop": "Back to top",
    "nav.skipToContent": "Skip to content",
    "nav.login": "Sign in",
    "nav.account": "My account",
    "nav.accountFor": "{name}'s account",
    "nav.logout": "Sign out",
    "language.label": "Language",
    "language.change": "Change language",

    "common.loading": "Loading...",
    "common.reset": "Reset",
    "common.all": "All",
    "common.allCategories": "All categories",
    "common.selectedCategory": "Selected category",
    "common.viewDetails": "View details",
    "common.productDetails": "Product details",
    "common.backToProducts": "Back to products",
    "common.backToLocations": "Back to locations",
    "common.unavailableAddress": "Address unavailable",
    "common.available": "available",
    "common.close": "Close",
    "common.previous": "Previous",
    "common.next": "Next",
    "common.image": "Image",
    "common.noImage": "No image",
    "common.optional": "optional",
    "common.retry": "Try again",
    "common.loadErrorTitle": "We couldn't load the menu",
    "common.loadError":
      "The connection is unavailable right now. Please try again.",
    "common.publicContentError":
      "Some restaurant information could not be refreshed.",
    "common.offlineTitle": "You're offline",
    "common.offline":
      "You can browse what is already loaded. Reconnect for current information and ordering.",
    "common.backOnline": "You're back online.",

    "portal.common.loading": "Loading...",
    "portal.common.retry": "Try again",
    "portal.common.sectionError":
      "We couldn't load this section. Please try again.",
    "portal.common.partialError":
      "Some information could not be loaded.",
    "portal.common.empty": "Nothing is available right now.",
    "portal.guard.restoring": "Restoring your account session",

    "portal.login.title": "Sign in to your account",
    "portal.login.subtitle": "See your QR code, points and offers.",
    "portal.login.optional":
      "You can still browse the menu and order without signing in.",
    "portal.login.expired":
      "Your session expired. Sign in again to continue.",
    "portal.login.username": "Username or email",
    "portal.login.password": "Password",
    "portal.login.submit": "Sign in",
    "portal.login.pending": "Signing in...",
    "portal.login.restoring": "Restoring your session...",
    "portal.login.failed":
      "We couldn't sign you in. Check your details and try again.",
    "portal.login.createTitle": "New here?",
    "portal.login.createText":
      "Create an account in a few steps and use it when you order.",
    "portal.login.createAction": "Create account",

    "portal.register.title": "Create your account",
    "portal.register.subtitle":
      "You can sign in and order as soon as it is created.",
    "portal.register.firstName": "First name",
    "portal.register.lastName": "Last name",
    "portal.register.email": "Email",
    "portal.register.county": "County",
    "portal.register.countiesLoading": "Loading counties...",
    "portal.register.countiesError": "We couldn't load the county list.",
    "portal.register.noCounties": "No matching county found.",
    "portal.register.city": "City",
    "portal.register.citiesLoading": "Loading cities...",
    "portal.register.citiesError": "We couldn't load the city list.",
    "portal.register.noCities": "No matching city found.",
    "portal.register.password": "Password",
    "portal.register.passwordConfirmation": "Repeat password",
    "portal.register.passwordHint":
      "At least 8 characters: uppercase, lowercase, number, and symbol.",
    "portal.register.submit": "Create account",
    "portal.register.pending": "Creating your account...",
    "portal.register.required": "Complete this field.",
    "portal.register.emailInvalid": "Enter a valid email address.",
    "portal.register.passwordInvalid":
      "The password does not meet the requirements above.",
    "portal.register.passwordMismatch": "Passwords do not match.",
    "portal.register.languageUnavailable":
      "The account language is not ready yet. Please try again.",
    "portal.register.exists":
      "An account with these details already exists. Try signing in.",
    "portal.register.failed":
      "We couldn't create the account. If it may already have been created, try signing in or come back a little later.",
    "portal.register.successTitle": "Account created",
    "portal.register.successText":
      "You can sign in and place orders right away.",
    "portal.register.validationInfo":
      "Check your email and validate the address to see your offers. You can place orders in the meantime.",
    "portal.register.haveAccount": "Already have an account?",
    "portal.register.haveAccountText":
      "Sign in to see your account information.",
    "portal.register.signIn": "Sign in",

    "portal.account.title": "My account",
    "portal.account.greeting": "Welcome, {name}!",
    "portal.account.fallbackName": "client",
    "portal.account.summary":
      "Your QR code, points, offers and news in one place.",
    "portal.account.emailValidationPending":
      "You can place orders now. Validate your email address to see your offers.",
    "portal.points.title": "Your points",
    "portal.points.one": "point",
    "portal.points.many": "points",
    "portal.points.unavailable": "Unavailable",
    "portal.points.rate": "1 point = 1 RON.",
    "portal.points.usage":
      "Use points in the mobile app or when ordering with our staff.",

    "portal.qr.title": "My QR code",
    "portal.qr.description": "Show this code when asked.",
    "portal.qr.imageLabel": "QR code for account identification",
    "portal.qr.code": "Code",
    "portal.qr.copy": "Copy code",
    "portal.qr.copied": "Copied",
    "portal.qr.copyFailed": "Select the code and copy it manually.",
    "portal.qr.validUntil": "Valid until {date}",
    "portal.qr.empty": "Your QR code is not available right now.",
    "portal.qr.emailValidationPending":
      "Your QR code will appear after you validate your email address.",

    "portal.offers.title": "Offers",
    "portal.offers.description":
      "See your available and claimed offers.",
    "portal.offers.productGroup": "Product offers",
    "portal.offers.comboGroup": "Combo offers",
    "portal.offers.voucherGroup": "Vouchers",
    "portal.offers.personalGroup": "Offers for you",
    "portal.offers.otherGroup": "Other offers",
    "portal.offers.fallback": "Offer",
    "portal.offers.personalFallback": "Personal offer",
    "portal.offers.claim": "Claim",
    "portal.offers.claiming": "Claiming...",
    "portal.offers.claimed": "Claimed",
    "portal.offers.claimSuccess": "Offer claimed.",
    "portal.offers.alreadyClaimed":
      "This offer is already claimed or is no longer available.",
    "portal.offers.claimUnavailable":
      "This offer can't be claimed right now.",
    "portal.offers.empty": "You have no offers right now.",
    "portal.offers.emailValidationPending":
      "Your offers will appear after you validate your email address.",
    "portal.offers.free": "Free",
    "portal.offers.fixedPrice": "Fixed price: {value} RON",
    "portal.offers.comboBasePrice":
      "Combo base price: {value} RON; extras may cost more",
    "portal.offers.comboBaseFree":
      "The combo base is free; extras may cost more",
    "portal.offers.fullCart":
      "Cart items are free; delivery is excluded",
    "portal.offers.fixed": "{value} RON off",
    "portal.offers.percentage": "{value}% off",
    "portal.offers.productScope": "For a product",
    "portal.offers.comboScope": "For a combo",
    "portal.offers.productComboScope":
      "Linked to both a product and a combo",
    "portal.offers.voucherScope":
      "Applies to the whole cart; delivery is excluded",
    "portal.offers.personalScope": "Assigned to your account",
    "portal.offers.useOnce": "Use once",
    "portal.offers.onceDaily": "Once a day",
    "portal.offers.onceWeekly": "Once a week",
    "portal.offers.onceMonthly": "Once a month",
    "portal.offers.ages": "For ages {from} to {to}",
    "portal.offers.ageFrom": "From age {age}",
    "portal.offers.ageTo": "Up to age {age}",
    "portal.offers.birthday": "Available on your birthday",
    "portal.offers.from": "From {date}",
    "portal.offers.until": "Until {date}",

    "portal.news.title": "News",
    "portal.news.description": "Latest updates for you.",
    "portal.news.fallback": "News",
    "portal.news.empty": "You have no news right now.",

    "home.subtitle": "Discover the restaurant's food and story.",
    "home.heroBrand":
      "Discover the food, atmosphere and story of {brand}.",
    "home.heroFallback":
      "Discover the restaurant's food, atmosphere and story.",
    "home.heroCarousel": "Campaigns and highlights",
    "home.showHero": "Show campaign",
    "home.viewProducts": "Discover the food",
    "home.findLocation": "Visit us",
    "home.quick.products": "Products",
    "home.quick.categories": "Categories",
    "home.quick.locations": "Locations",
    "home.quick.app": "App",
    "home.quick.order": "Order",
    "home.card.products.title": "Products prepared with care",
    "home.card.products.text": "Quickly browse available products and discover your favourites.",
    "home.card.fast.title": "Fast experience",
    "home.card.fast.text": "Simple, clear navigation optimized for mobile.",
    "home.card.locations.title": "Locations nearby",
    "home.card.locations.text": "Easily find the locations available to you.",
    "home.featuredStories": "Stories and updates",
    "home.popularCategories": "Discover the menu",
    "home.popularCategoriesDesc": "Explore a selection from the restaurant menu.",
    "home.allProducts": "Discover the full menu",
    "home.recommendations": "Food to discover",
    "home.recommendationsDesc": "A selection from the restaurant menu.",
    "home.viewAll": "View all",
    "home.recommended": "Recommended",
    "home.product": "Product",
    "home.appTitle": "Your restaurant, closer to you.",
    "home.appDesc":
      "Discover the menu, updates and benefits available in the app.",
    "home.downloadApp": "Download the app",
    "home.viewMenu": "View menu",
    "home.nearestLocation": "Come and visit us",
    "home.locationsDesc": "Discover our restaurants, addresses and useful information for your visit.",
    "home.viewLocations": "Discover our restaurants",
    "home.appAlt": "Restaurant app",
    "home.locationsEmpty": "Available locations will appear here.",

    "products.heroTitle": "Discover our menu.",
    "products.heroSubtitle": "Explore the food and find the right taste for your moment.",
    "products.displayed": "products shown",
    "products.count": "products",
    "products.activeFilter": "Active filter",
    "products.search": "Search product...",
    "products.explore": "Explore menu",
    "products.loadingTitle": "Loading products",
    "products.loadingDesc": "Preparing the available menu for this location.",
    "products.errorTitle": "We could not load products",
    "products.emptyTitle": "No products found",
    "products.emptyDesc": "Try another word or select another category.",
    "products.resetFilters": "Reset filters",
    "products.notFoundTitle": "Product was not found.",
    "products.notFoundDesc": "Check the list of available products.",
    "products.new": "New product",
    "products.newShort": "New",
    "products.deliverable": "Available for delivery",
    "products.allergens": "Allergens",

    "locations.heroTitle": "Our restaurants.",
    "locations.heroSubtitle":
      "Discover where to find us and useful information for your next visit.",
    "locations.displayed": "locations shown",
    "locations.count": "locations",
    "locations.cityOne": "city available",
    "locations.cityMany": "cities available",
    "locations.searchLong": "Search by city, address or phone...",
    "locations.searchShort": "City, address or phone...",
    "locations.find": "Find location",
    "locations.loadingTitle": "Loading locations",
    "locations.loadingDesc": "Preparing the list of available locations.",
    "locations.errorTitle": "We could not load locations",
    "locations.emptyTitle": "No locations found",
    "locations.emptyDesc": "Try searching by city, address or phone number.",
    "locations.resetSearch": "Reset search",
    "locations.notFoundTitle": "Location was not found.",
    "locations.notFoundDesc": "Check the list of available locations.",
    "locations.location": "Location",
    "locations.call": "Call",
    "locations.directions": "Directions",
    "locations.copyAddress": "Copy address",
    "locations.map": "Map",
    "locations.about": "About location",
    "locations.schedule": "Schedule",

    "appDownload.app": "Restaurant App",
    "appDownload.alt": "Restaurant app",
    "appDownload.install": "Install the app",
    "appDownload.subtitle":
      "Order more easily and enjoy the benefits available in your account.",
    "appDownload.copy":
      "Get quick access to products, personalized promotions, loyalty points and a simpler experience with every order.",
    "appDownload.fast": "Order faster",
    "appDownload.loyalty": "Promotions and loyalty",
    "appDownload.simple": "Everything at hand",
    "appDownload.appStore": "Download on the App Store",
    "appDownload.playStore": "Get it on Google Play",
    "appDownload.availability":
      "App availability may vary depending on device and app store.",
    "appDownload.unavailableTitle": "App downloads are unavailable",
    "appDownload.unavailable":
      "No verified app-store download is currently available. You can continue using this website.",

    "productInfo.new": "New",
    "productInfo.close": "Close product details",
    "productInfo.description": "Description",
    "productInfo.ingredients": "Ingredients",
    "productInfo.allergens": "Allergens",
    "productInfo.nutrition": "Nutrition information",
    "productInfo.details": "Details",
    "productInfo.emptyTitle": "Product information",
    "productInfo.emptyText": "No additional details are available for this product.",
    "nutrition.energy": "Energy",
    "nutrition.protein": "Protein",
    "nutrition.carbs": "Carbohydrates",
    "nutrition.sugars": "Sugars",
    "nutrition.fat": "Fat",
    "nutrition.salt": "Salt",
    "nutrition.weight": "Weight",

    "mobile.emailUnavailable": "Unavailable",
    "mobile.closeWhenFinished": "You can safely close this page when finished.",
    "mobile.validateEmailTitle": "Email verification",
    "mobile.validateEmailIntro": "We are confirming the email address for your account.",
    "mobile.invalidEmailLink": "Invalid or incomplete email verification link.",
    "mobile.emailVerificationFailed": "Email verification could not be completed.",
    "mobile.emailChecking": "Checking your email verification link.",
    "mobile.invalidResetLink": "Invalid or incomplete password reset link.",
    "mobile.resetPasswordTitle": "Reset password",
    "mobile.resetPasswordIntro": "Choose a new password for your account.",
    "mobile.resetPasswordSuccessTitle": "Password changed",
    "mobile.resetPasswordSuccessText": "You can return to the app and sign in with your new password.",
    "mobile.openResetAgain": "Please open the reset link again from the email you received.",
    "mobile.passwordMismatch": "Passwords do not match.",
    "mobile.passwordChanged": "Password changed.",
    "mobile.passwordNotChanged": "Password was not changed.",
    "mobile.newPassword": "New password",
    "mobile.repeatPassword": "Repeat password",
    "mobile.passwordHint": "Use at least 8 characters with uppercase, lowercase, number, and symbol.",
    "mobile.changePassword": "Change password",
    "mobile.showPassword": "Display the password",
    "mobile.hidePassword": "Hide the password",

    "days.1": "Monday",
    "days.2": "Tuesday",
    "days.3": "Wednesday",
    "days.4": "Thursday",
    "days.5": "Friday",
    "days.6": "Saturday",
    "days.7": "Sunday",
    "days.day": "Day",

    "skipline.tagline": "Order quickly and pick up in store",
    "skipline.chooseLocation": "Choose location",
    "skipline.chooseLocationDesc": "Select the county and location where you want to pick up your order.",
    "skipline.searchLocation": "Search county, city or location...",
    "skipline.termsPrefix": "{brand} official page · secure payment through {provider}. By continuing, you agree to",
    "skipline.terms": "Terms",
    "skipline.and": "and",
    "skipline.privacy": "Privacy Policy",
    "skipline.noLocations": "No locations are available for online orders.",
    "skipline.noSearchLocations": "No locations matched your search.",
    "skipline.locationOne": "location",
    "skipline.locationMany": "locations",
    "skipline.choose": "Choose",
    "skipline.change": "Change",
    "skipline.startOrder": "Start your order",
    "skipline.emailNeeded": "We need your email to process the online payment.",
    "skipline.openNow": "Open now",
    "skipline.closedNow": "Closed now",
    "skipline.canContinue": "You can continue the order for pickup from this location.",
    "skipline.onlineUnavailable": "Online orders are not available right now.",
    "skipline.paymentEmail": "Payment email",
    "skipline.invalidEmail": "Invalid email",
    "skipline.emailHelp": "Email is used only for payment processing.",
    "skipline.continueMenu": "Continue to menu",
    "skipline.menuOnlyOpen": "The menu is available only when the location accepts online orders.",
    "skipline.noAccount": "We do not create a customer account. The data is used for this order.",
    "skipline.selectedLocation": "Selected location",
    "skipline.homeIntro": "Order quickly, pay online and pick up in store.",
    "skipline.chooseCategory": "Choose category",
    "skipline.chooseCategoryDesc": "Select a category to view available products.",
    "skipline.noCategories": "No categories are available for this location.",
    "skipline.viewProducts": "View products",
    "skipline.chooseCombo": "Choose combo",
    "skipline.add": "Add",
    "skipline.combo": "Combo",
    "skipline.promo": "Promo",
    "skipline.product": "Product",
    "skipline.cart": "Cart",
    "skipline.yourOrder": "Your order",
    "skipline.totalOrder": "Order total",
    "skipline.menu": "Menu",
    "skipline.allMenu": "Full menu",
    "skipline.allProducts": "All products",
    "skipline.availableProducts": "{count} products available",
    "skipline.open": "Open",
    "skipline.closed": "Closed",
    "skipline.viewCart": "View cart",
    "skipline.clearCart": "Clear",
    "skipline.checkout": "Continue to payment",
    "skipline.noProductsCategory": "No products found in this category.",
    "skipline.itemOne": "item",
    "skipline.itemMany": "items",
    "skipline.inCart": "in cart",
    "skipline.piece": "pc",
    "skipline.emptyCart": "Cart is empty",
    "skipline.emptyCartDesc": "Add products from the menu to continue your order.",
    "skipline.backToMenu": "Back to menu",
    "skipline.securePayment":
      "Payment is processed securely through {provider}. Enter card details only on the {provider} page opened from this order.",
    "skipline.closeCart": "Close cart",
    "skipline.searchMenu": "Search menu...",
    "skipline.clearFilter": "Clear filter",
    "skipline.loadingMenu": "We could not load the menu.",
    "skipline.loadingInit": "We could not initialize the page.",
    "skipline.loadingSelectedLocation": "We could not load the menu for the selected location.",
    "skipline.locationChangeConfirm": "Changing location will clear the cart. Continue?",
    "skipline.otherCity": "Other city",
    "skipline.noPaymentLink": "We did not receive the payment link.",
    "skipline.addItems": "Add products to cart.",
    "skipline.enterPaymentEmail": "Enter a valid email address for online payment.",
    "skipline.orderRegistered": "The order was registered. To confirm it, continue to online card payment.",
    "skipline.orderError": "An error occurred while placing the order.",
    "skipline.vatUnavailable":
      "We cannot calculate VAT for one of the products in your order. Reload the menu or choose the product again.",
    "skipline.orderAddUncertain":
      "We could not confirm whether the order was created. Do not automatically retry; verify its status before placing another order.",
    "skipline.paymentRegistrationFailed":
      "The order is retained, but payment setup failed. Retry payment for this same order.",
    "skipline.retryPaymentRegistration": "Retry payment setup",
    "skipline.clientSessionRequired":
      "Your session expired. Sign in again to continue this same order.",
    "skipline.clientSessionRestoring":
      "We're restoring your session. Try again in a moment.",
    "skipline.authenticatedPaymentUnavailable":
      "Payment for an account order is not available right now.",
    "skipline.clientCheckoutActive": "Order from your account",
    "skipline.clientSignedIn": "You're signed in",
    "skipline.clientLogout": "Sign out",
    "skipline.clientSignInForCheckout": "Have an account?",
    "skipline.clientSignInHelp":
      "Sign in without losing the items in your cart.",
    "skipline.clientBaseOrderHelp":
      "This order will be linked to your account. Points and offers are not applied to website orders.",
    "skipline.clientBenefitsUnavailable":
      "Website orders can't include points or offers from your account.",
    "skipline.clientAccountEmailReady":
      "This order will be linked to your account. We'll use the email saved on your account.",
    "skipline.clientAccountEmailMissing":
      "We can't place this order because your account doesn't have a valid email address. Contact us to update your account, or sign out and order without an account.",
    "skipline.paymentSuccess": "Payment was processed successfully.",
    "skipline.paymentPending": "Payment is not completed yet. After confirming payment, press \"I paid\".",
    "skipline.paymentCanceled": "Payment was canceled. You can try again.",
    "skipline.paymentCheckFailed": "We could not check payment status.",
    "skipline.paymentStatus": "Payment status: {status}.",
    "skipline.cancelFailed": "We could not cancel the order. Please try again.",
    "skipline.locationUnavailable": "This location does not accept orders right now.",
    "skipline.noLocationInfo": "No location information.",
    "skipline.inactiveLocation": "The location is inactive.",
    "skipline.unsupportedServeType": "This location does not accept orders in this mode.",
    "skipline.noTodaySchedule": "There is no schedule for today.",
    "skipline.closedSchedule": "Closed now. Today's schedule: {open}-{close} (online orders).",

    "payment.finalize": "Finalize payment",
    "payment.confirmedAfter": "The order is confirmed after online payment is processed.",
    "payment.close": "Close payment",
    "payment.online": "Online payment",
    "payment.secure":
      "Payment is processed securely through {provider}. {owner} does not request or store card details.",
    "payment.secureTitle": "Secure payment",
    "payment.openOnline": "Open online payment",
    "payment.cardOnlyProvider":
      "Enter card details only on the {provider} page opened from this order. After payment is completed, return here to check the status.",
    "payment.stepPay": "Complete payment in the secure window.",
    "payment.stepReturn": "Return here and press \"I paid\".",
    "payment.checking": "Checking payment status...",
    "payment.afterPay": "After completing payment, press \"I paid\" to check it.",
    "payment.iPaid": "I paid",
    "payment.checkingShort": "Checking...",
    "payment.cancel": "Cancel",
    "payment.registrationFailed":
      "Payment setup failed, but the known order has been retained.",
    "payment.retryRegistration": "Retry payment for this same order",
    "payment.retryingRegistration": "Retrying payment...",
    "payment.sameOrderRetry": "This action does not create a new order.",
    "payment.clientSessionRequired":
      "Sign in again before resuming this order.",
    "payment.clientUsername": "Username or email",
    "payment.clientPassword": "Password",
    "payment.clientSignIn": "Sign in",
    "payment.clientSigningIn": "Signing in...",
    "payment.clientLoginFailed":
      "Sign-in failed. Check your details or try again later.",

    "combo.optionsFor": "Options for: {combo}",
    "combo.included": "Included in combo",
    "combo.includedPrice": "0 RON (included)",
    "combo.edit": "Edit",
    "combo.back": "Back",
    "combo.addToCart": "Add to cart",
    "combo.total": "Combo total",

    "summary.confirmed": "Order confirmed",
    "summary.order": "Order",
    "summary.orderedProducts": "Ordered products",
    "summary.keepConfirmation": "Keep this confirmation. Pick up the product from the location when it is ready.",
    "summary.totalPaid": "Total paid",
    "summary.newOrder": "New order",
  },
};

export function getLanguageCode(language, fallback = FALLBACK_LANGUAGE_CODE) {
  if (!language) return NORMALIZE_CODE(fallback) || FALLBACK_LANGUAGE_CODE;
  return NORMALIZE_CODE(language.countryShortName || language.code || language.value || fallback);
}

export function getLanguageIref(language) {
  if (!language) return "";
  return String(language.iref || language.id || "").trim();
}

export function isSupportedLanguage(language) {
  return SUPPORTED_LANGUAGE_CODES.includes(getLanguageCode(language));
}

export function filterSupportedLanguages(languages) {
  return (languages || []).filter(isSupportedLanguage);
}

export function createTranslator(languageCode) {
  const code = NORMALIZE_CODE(languageCode) || FALLBACK_LANGUAGE_CODE;
  const primary = LABELS[code] || LABELS[FALLBACK_LANGUAGE_CODE];
  const fallback = LABELS[FALLBACK_LANGUAGE_CODE];

  return (key, fallbackText = "") => {
    return primary?.[key] || fallback?.[key] || fallbackText || key;
  };
}

export function getTranslationLanguageIref(item) {
  const language = item?.language;
  if (!language) return "";
  if (typeof language === "string") return language;
  return getLanguageIref(language);
}

export function findLanguage(languages, value) {
  const wanted = NORMALIZE_CODE(value);
  const raw = String(value || "").trim();
  if (!wanted && !raw) return null;

  return (
    (languages || []).find((lang) => {
      return (
        String(lang?.iref || "").trim() === raw ||
        NORMALIZE_CODE(lang?.countryShortName) === wanted ||
        NORMALIZE_CODE(lang?.languageName) === wanted
      );
    }) || null
  );
}

export function resolveDefaultLanguage(languages, defaultValue) {
  return (
    findLanguage(languages, defaultValue) ||
    findLanguage(languages, FALLBACK_LANGUAGE_CODE) ||
    (languages || [])[0] ||
    null
  );
}

export function resolveSelectedLanguage(languages, selectedValue, defaultLanguage) {
  return findLanguage(languages, selectedValue) || defaultLanguage || (languages || [])[0] || null;
}

export function pickTranslation(translations, selectedLanguage, defaultLanguage) {
  const list = Array.isArray(translations) ? translations : [];
  if (!list.length) return null;

  const selectedIref = getLanguageIref(selectedLanguage);
  const defaultIref = getLanguageIref(defaultLanguage);

  return (
    list.find((item) => getTranslationLanguageIref(item) === selectedIref) ||
    list.find((item) => getTranslationLanguageIref(item) === defaultIref) ||
    null
  );
}

export function applyEntityTranslation(entity, translationKey, selectedLanguage, defaultLanguage) {
  if (!entity || !translationKey) return entity;
  const translated = pickTranslation(entity[translationKey], selectedLanguage, defaultLanguage);
  if (!translated) return entity;

  const next = { ...entity };
  ["name", "shortName", "description", "spec"].forEach((key) => {
    if (translated[key] !== undefined && translated[key] !== null && String(translated[key]).trim() !== "") {
      next[key] = translated[key];
    }
  });

  return next;
}

export function getTextConfigValue(data, fallback = "", selectedLanguage, defaultLanguage) {
  if (!data) return fallback;
  if (typeof data === "string") return data;

  const list = Array.isArray(data) ? data : data?.MobileAppTextConfigs || [];
  if (!Array.isArray(list)) return fallback;

  const selectedIref = getLanguageIref(selectedLanguage);
  const defaultIref = getLanguageIref(defaultLanguage);

  const item =
    list.find((x) => x?.value && getTranslationLanguageIref(x) === selectedIref) ||
    list.find((x) => x?.value && getTranslationLanguageIref(x) === defaultIref) ||
    list.find((x) => x?.value) ||
    null;

  return item?.value || fallback;
}

export function getAllergenTranslation(allergen, selectedLanguage, defaultLanguage) {
  const translated = pickTranslation(allergen?.allergent_allergen, selectedLanguage, defaultLanguage);
  return {
    ...allergen,
    name: translated?.name || allergen?.name || "",
    description: translated?.description || allergen?.description || "",
  };
}

export function withLanguageParam(path, languageIref) {
  if (!languageIref) return path;
  const joiner = String(path).includes("?") ? "&" : "?";
  return `${path}${joiner}language=${encodeURIComponent(languageIref)}`;
}
